import { Spin } from "antd";
import { useEffect, useState } from "react";
import { IoIosWarning } from "react-icons/io";
import { useForm, SubmitHandler } from "react-hook-form";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "Components/Breadcrums";
import FormControl from "Components/FormControl";
import { showErrorAlert, showWarningAlert, Toast } from "Util/Alerts";
import { breadcrumbItems, formFields } from "./Constant";
import { Types } from "./Types";
import { add_Clients, update_Clients } from "Services/Requests";
import Styles from "Styles/Styles.module.css";

window.Buffer = window.Buffer || require("buffer").Buffer;

function AddClient() {
    const navigate = useNavigate();
    const { type } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    const [ErrorMsg, setErrorMsg] = useState<null | string>(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm<Types>();

    const onSubmit: SubmitHandler<Types> = async (data) => {
        try {
            setLoading(true);
            let response;
            if (type === "edit") {
                let body: any = { ...data };
                delete body?.password;
                response = await update_Clients(location.state?.clientId, body);
            } else {
                response = await add_Clients(data);
            }
            if (response?.data?.Status === 1) {
                Toast(response?.data?.Message, "success");
                navigate(-1);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong, try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (type === "edit") {
            let formData = location.state;

            reset({ ...formData });
        }
    }, [type, location.state, reset]);

    return (
        <div className={Styles["Add_form_wrapper"]}>
            <h3>
                <span style={{ textTransform: "capitalize" }}>{type}</span>{" "}
                Client
            </h3>
            <Breadcrumb items={breadcrumbItems} type={type} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={Styles["form"]}>
                    <h4>Client</h4>

                    {formFields.map((field) => (
                        <FormControl
                            key={field.name}
                            label={field.label}
                            name={field.name}
                            register={register}
                            errors={errors[field.name]}
                            requiredMessage={field.required}
                            type={field.type}
                            options={field.options || []}
                            validate={field?.validate}
                            isDisabled={
                                field.name == "password" && type === "edit"
                                    ? true
                                    : false
                            }
                        />
                    ))}

                    {ErrorMsg && (
                        <p className={Styles["Gen-erro_msg"]}>
                            <IoIosWarning /> {ErrorMsg}
                        </p>
                    )}
                </div>

                {loading ? (
                    <Spin size="default" />
                ) : (
                    <button>{type === "edit" ? "Update" : "Add"}</button>
                )}
            </form>
        </div>
    );
}

export default AddClient;
